import { render } from "./directormessageView.vue?vue&type=template&id=57ba9ce8"
import script from "./directormessageView.vue?vue&type=script&lang=js"
export * from "./directormessageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__